export default {
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    modalTitle: {
      type: String,
      default: '',
    },
  },
};
